import { PesoAutorreferidoEnum } from 'graphql/types.generated'
import React from 'react'

import { RadioGroupField, RadioGroupFieldProps, RadioOption } from './RadioGroupField'

type PesoAutorreferidoRadioGroupFieldProps = Omit<RadioGroupFieldProps<PesoAutorreferidoEnum>, 'label' | 'options'>

export function PesoAutorreferidoRadioGroupField(props: PesoAutorreferidoRadioGroupFieldProps) {
  return <RadioGroupField options={options} {...props} />
}

const options: RadioOption<PesoAutorreferidoEnum>[] = [
  { value: PesoAutorreferidoEnum.ABAIXO_DO_PESO, label: 'Abaixo do peso' },
  { value: PesoAutorreferidoEnum.PESO_ADEQUADO, label: 'Peso adequado' },
  { value: PesoAutorreferidoEnum.ACIMA_DO_PESO, label: 'Acima do peso' },
]
